import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IPinpointStore} from "data/stores/pinpoint/pinpoint.store";
import type {IRound, IRoundsStore, ISession} from "data/stores/rounds/rounds.store";
import type {IUserStore} from "data/stores/user/user.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";

export interface IGameController extends ViewController {
	get i18n(): ILocalizationStore;
	get isLoading(): boolean;

	get rounds(): IRound[];

	get nextUpSessions(): ISession[];
	get upcomingSessions(): ISession[];
	get editSessions(): ISession[];
	get liveSessions(): ISession[];
	get completedSessions(): ISession[];
	get notLiveOrCompletedSessions(): ISession[];
}

@injectable()
export class GameController implements IGameController {
	@observable private _isLoading: boolean = false;

	constructor(
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.PinpointStore) private _pinpointStore: IPinpointStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get isLoading() {
		return this._isLoading;
	}

	get rounds() {
		return this._roundStore.list;
	}

	get nextUpSessions() {
		return this._roundStore.nextUpSessions;
	}

	get upcomingSessions() {
		return this._roundStore.upcomingSessions;
	}

	get editSessions() {
		return this._roundStore.editSessions;
	}

	get liveSessions() {
		return this._roundStore.liveSessions;
	}

	get completedSessions() {
		return this._roundStore.completedSessions;
	}

	get notLiveOrCompletedSessions() {
		return this._roundStore.notLiveOrCompletedSessions;
	}

	async init() {
		if (this._userStore.isAuthorized) {
			await this._pinpointStore.fetchListOfMyPicks();
		}
	}
}
